// extracted by mini-css-extract-plugin
export default {"avatar":"style_avatar__j2Y5w","user":"style_user__HF5oO","name":"style_name__Bik5h","role":"style_role__9C-w8","icon":"style_icon__+a1Va"};